import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { useWindowDimensions } from 'react-native';
import { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { popStateLockedMap } from '../../navigatorEmbed/UtxAppNavigatorEmbed';

interface UseNativeModalViewParams {
  onBack?: () => void;
}

export const useNativeModalView = ({ onBack }: UseNativeModalViewParams) => {
  const dimensions = useWindowDimensions();
  const navigation = useNavigation();

  const right = useSharedValue(-dimensions.width);

  const animatedStyle = useAnimatedStyle(() => ({
    right: withTiming(right.value, { duration: 300 })
  }));

  useEffect(() => {
    right.value = 0;
  }, []);

  const handleBack = () => {
    right.value = -dimensions.width;
    setTimeout(() => {
      onBack && onBack();
      popStateLockedMap.set('popstate', true); // lock popstate listener events
      navigation.goBack();
      setTimeout(() => popStateLockedMap.set('popstate', false), 500); // reset lock popstate listener events
    }, 500);
  };

  return {
    animatedStyle,
    handleBack
  };
};
